import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
// Side-effect import: initialises i18next before the first render, so
// the first paint is already in the right language. An async catalogue
// would open in English and change under the reader.
import './lib/i18n';
import './styles.css';

// The conversation wallpaper, shared with the phone rather than a lookalike:
// this is the same 480px tile `chatThemes.ts` requires. Set as a CSS variable
// so the stylesheet can use it without hard-coding a bundler URL.
import chatPattern from '@nsibi/ui-rn/assets/chat-bg.png';

document.documentElement.style.setProperty('--chat-pattern', `url(${chatPattern})`);

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
